
import axios from "axios";
import { adminMainUrl } from "../../Config";

//side bar and navbar//
export const fetchSidebarPermissionRequest = () => ({
    type: "FIND_SIDEBAR_PERMISSION_REQUEST",
});

export const fetchSidebarPermissionSuccess = (data) => ({
    type: "FIND_SIDEBAR_PERMISSION_SUCCESS",
    payload: data,
});

export const fetchSidebarPermissionFailure = (error) => ({
    type: "FIND_SIDEBAR_PERMISSION_FAILURE",
    payload: error,
});


export const getSidebarPermission = (token) => {
    return async function (dispatch) {
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'Content-Type': 'application/json',
            }
        };
        // await fetch(`${adminMainUrl}/api/get-user-permission`, config)
        await fetch(`${adminMainUrl}/api/get-profile-new`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchSidebarPermissionSuccess(resData?.data));
                });
            }).catch((err) => {
                console.log("ERROR in SidebarPermission function(redux):", err);
            })
    }
};

//sidebar and navbar//


//side bar and navbar//
export const fetchSidebarPermissionHRMSRequest = () => ({
    type: "FIND_SIDEBAR_PERMISSION_HRMS_REQUEST",
});

export const fetchSidebarPermissionHRMSSuccess = (data) => ({
    type: "FIND_SIDEBAR_PERMISSION_HRMS_SUCCESS",
    payload: data,
});

export const fetchSidebarPermissionHRMSFailure = (error) => ({
    type: "FIND_SIDEBAR_PERMISSION_HRMS_FAILURE",
    payload: error,
});


export const getSidebarPermissionHRMS = (token, user_id) => {
    return async function (dispatch) {
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': Number(user_id),
                'Content-Type': 'application/json',
            }
        };
        // await fetch(`${adminMainUrl}/api/get-user-permission`, config)
        await fetch(`${adminMainUrl}/api/get-profile-new`, config)
            .then((res) => {
                res.json().then((resData) => {
                    if (resData.code == '200') {
                        dispatch(fetchSidebarPermissionHRMSSuccess(resData?.data));
                    } else {
                        dispatch(fetchSidebarPermissionHRMSFailure(resData?.msg));
                    }
                })
            }).catch((err) => {
                dispatch(fetchSidebarPermissionHRMSFailure(err.message));
                console.log("ERROR in getSidebarPermissionHRMS function(redux):", err);
            })
    }
};

//sidebar and navbar//

//notification//
export const fetchNotificationRequest = () => ({
    type: "FIND_NOTIFICATION_REQUEST",
});

export const fetchNotificationSuccess = (data) => ({
    type: "FIND_NOTIFICATION_SUCCESS",
    payload: data,
});

export const fetchNotificationFailure = (error) => ({
    type: "FIND_NOTIFICATION_FAILURE",
    payload: error,
});


export const getNotification = (token, user_id) => {
    // console.log(token,user_id);
    return async function (dispatch) {
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': Number(user_id),
                'Content-Type': 'application/json',
            }
        };
        // await fetch(`${adminMainUrl}/api/get-user-permission`, config)
        await fetch(`${adminMainUrl}/api/notification/get`, config)
            .then((res) => {
                res.json().then((resData) => {
                    if (resData.code == '200') {
                        dispatch(fetchNotificationSuccess(resData?.data));
                    } else {
                        dispatch(fetchNotificationFailure(resData?.msg));
                    }
                })
            }).catch((err) => {
                dispatch(fetchNotificationFailure(err.message));
                console.log("ERROR in getNotification function(redux):", err);
            })
    }
};

//notificaion//

//company details
export const getCompanyDetails = () => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_COMPANY_DETAILS_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/company-detail`;
        try {
            axios.get(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_COMPANY_DETAILS_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getCompanyDetails function (redux):", err);
                dispatch({
                    type: "FIND_COMPANY_DETAILS_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getCompanyDetails function:", error);
            dispatch({
                type: "FIND_COMPANY_DETAILS_FAILURE",
                payload: error,
            });
        }
    };
};